import React from 'react';
export default (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    fill="currentColor"
  >
    <path
      className="st0"
      d="M5,14.8c1.1,0,2-0.9,2-2s-0.9-2-2-2c-1.1,0-2,0.9-2,2S3.9,14.8,5,14.8z M19,14.8c1.1,0,2-0.9,2-2s-0.9-2-2-2
	s-2,0.9-2,2S17.9,14.8,19,14.8z M20,15.8h-2c-0.5,0-1,0.2-1.4,0.6c1.3,0.7,2.2,1.9,2.3,3.4H21c0.6,0,1-0.4,1-1v-1
	C22,16.7,21.1,15.8,20,15.8z M12,15.8c1.9,0,3.5-1.6,3.5-3.5S13.9,8.8,12,8.8s-3.5,1.6-3.5,3.5S10.1,15.8,12,15.8z M14.4,16.8h-0.3
	c-0.7,0.3-1.4,0.5-2.1,0.5s-1.5-0.2-2.1-0.5H9.6c-2,0-3.6,1.6-3.6,3.6v0.9c0,0.8,0.7,1.5,1.5,1.5h9c0.8,0,1.5-0.7,1.5-1.5v-0.9
	C18,18.4,16.4,16.8,14.4,16.8z M7.4,16.4C7,16,6.6,15.8,6,15.8H4c-1.1,0-2,0.9-2,2v1c0,0.6,0.4,1,1,1h2.1
	C5.3,18.3,6.2,17.1,7.4,16.4z"
    />
    <path
      className="st0"
      d="M8.7,3.1v2.9c0,0.3,0.2,0.5,0.5,0.5h5.6c0.3,0,0.5-0.2,0.5-0.5V3.1c0-0.4-0.5-0.6-0.8-0.4l-0.7,0.6
	c-0.2,0.2-0.6,0.1-0.7-0.1l-0.6-0.9c-0.2-0.3-0.6-0.3-0.8,0L11,3.1c-0.2,0.2-0.5,0.3-0.7,0.1L9.5,2.7C9.2,2.4,8.7,2.7,8.7,3.1z"
    />
  </svg>
);
